var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_884_2129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_884_2129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 14.5L8.86667 10.3C8.53333 10.5667 8.15 10.7778 7.71667 10.9333C7.28333 11.0889 6.82222 11.1667 6.33333 11.1667C5.12222 11.1667 4.09722 10.7472 3.25833 9.90833C2.41944 9.06944 2 8.04444 2 6.83333C2 5.62222 2.41944 4.59722 3.25833 3.75833C4.09722 2.91944 5.12222 2.5 6.33333 2.5C7.54444 2.5 8.56944 2.91944 9.40833 3.75833C10.2472 4.59722 10.6667 5.62222 10.6667 6.83333C10.6667 7.32222 10.5889 7.78333 10.4333 8.21667C10.2778 8.65 10.0667 9.03333 9.8 9.36667L14 13.5667L13.0667 14.5ZM6.33333 9.83333C7.16667 9.83333 7.875 9.54167 8.45833 8.95833C9.04167 8.375 9.33333 7.66667 9.33333 6.83333C9.33333 6 9.04167 5.29167 8.45833 4.70833C7.875 4.125 7.16667 3.83333 6.33333 3.83333C5.5 3.83333 4.79167 4.125 4.20833 4.70833C3.625 5.29167 3.33333 6 3.33333 6.83333C3.33333 7.66667 3.625 8.375 4.20833 8.95833C4.79167 9.54167 5.5 9.83333 6.33333 9.83333Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.901336b298dac2915159300d75975a40.svg";
export { ForwardRef as ReactComponent };